// extracted by mini-css-extract-plugin
export default {"root":"ArticlesWidget_root__e4qqb","header":"ArticlesWidget_header__E2HHF","body":"ArticlesWidget_body__VfoKn","footer":"ArticlesWidget_footer__Y40hN"};